// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge[data-v-4872c9fc]{border:1px solid #001e50;padding:8px 12px;display:inline-flex;align-items:center}.badge i[data-v-4872c9fc]{margin-right:8px;font-size:14px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
